<template>
    <div v-if="list.length"
        class="list_nav_wrap toggle-nav">
        <h1 class="list_nav_title">
            <label>{{ keyName }}</label>
        </h1>  
        <div class="sc-option" data-ui="dropdown" id="brand_option" style="z-index: 1000;">
            <div class="sc-option-hd">
                <div class="sc-option-content">
                    {{ activeName }}
                </div>
                <div class="sc-option-action">
                    <i></i>
                </div>
            </div>
            <div class="sc-option-list cars-sc hidden" style="top: 25px;">
                <ul v-for="group in list"
                    class="cars-sc-lists cars-sc-last clearfix">
                    <div class="panel">
                        {{ group.groupName }}
                    </div>
                    <li v-for="item in group.groupValue">
                        <a :class="{
                                'listNav_active': active === item.code
                            }"
                            @click="doSelect(item.code)">{{ item.name }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    let formBean = window._qiwa.page_global.formBean;
    export default {
        data() {
            return {
                key: 'carSeries',
                keyName: '车系',
                active: locationObj.search.get('carSeries'),
                activeName: formBean.seriesName || '请选择车系',
                list: window._qiwa.page_global.seriesListByFormBeanBrand
            };
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj.s(this.key, value).s('index', null).go();
                } else {
                    locationObj.s(this.key, null).s('index', null).go();
                }
            }
        },
        mounted() {
            let $ = window.$;
            $('body').click((event) => {
                if (!$(event.target).closest('.sc-option').length) {
                    this.show = false;
                }
            });
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavSeries.vue?78c2fd7a